import { Ref, ref, computed } from "vue";
import { KoyouKeiyakuTimeService } from "@/service/KoyouKeiyakuTimeService";
import { KoyouKeiyakuTime } from "@/types/KoyouKeiyaku";
import { KoyouKeiyakuTimeAndHayabanOsobanOption, KoyouKeiyakuTimeAndHayabanOsobanOptions, KoyouKeiyakuTimeOptions } from "@/types/KoyouKeiyakuTime";

/*
 * 初期処理
 */
export function useKoyouKeiyakuTimeInit() {
  const loading = ref(0) // APIで読み込みをする本数
  const isError = ref(false)

  // 雇用契約就業時間データ保存用
  let koyouKeiyakuList: Ref<KoyouKeiyakuTime[]> = ref([])
  let selectedKoyouKeiyakuTime: Ref<KoyouKeiyakuTime | null> = ref(null);

  // 雇用契約就業時間オプション値保存用
  let koyouKeiyakuTimeOptions: Ref<KoyouKeiyakuTimeOptions[]> = ref([])
  let selectedKoyouKeiyakuTimeOption: Ref<KoyouKeiyakuTimeOptions | null> = ref(null);

  // 雇用契約就業時間オプション値保存用
  let koyouKeiyakuTimeAndHayabanOsobanOptions: Ref<KoyouKeiyakuTimeAndHayabanOsobanOptions> = ref({
    hayabanOsobanOpt: [],
    koyouKeiyakuTimeOpt: [],
    koyouType: null,
    sashihikiTime: null
  })
  let selectedTimeAndHayabanOsoban: Ref<KoyouKeiyakuTimeAndHayabanOsobanOption | null> = ref(null);

  const koyouKeiyakuvice = new KoyouKeiyakuTimeService()

  /**
   * マスタに登録されている全ての雇用契約就業時間を取得します
   */
  const getByKoyouKeiyakuId = async (koyouKeiyakuId: number | null) => {
    loading.value++
    koyouKeiyakuList.value = await koyouKeiyakuvice.getByKoyouKeiyakuId(koyouKeiyakuId);
    loading.value--
  }

  /**
   * マスタに登録されている全ての雇用契約就業時間を取得します（オプション値）
   */
  const getOptionsByKoyouKeiyakuId = async (koyouKeiyakuId: number | null) => {
    loading.value++
    koyouKeiyakuTimeOptions.value = await koyouKeiyakuvice.getOptionsByKoyouKeiyakuId(koyouKeiyakuId);
    loading.value--
  }

  /**
   * 指定したユーザーの有効な雇用契約就業時間を取得します
   * @param userId? ユーザーID（指定しない場合はログイン中のユーザー）
   */
  const getByKoyouKeiyakuIdAndDate = async (koyouKeiyakuId: number | null, date: string | Date | null) => {
    loading.value++
    koyouKeiyakuList.value = await koyouKeiyakuvice.getByKoyouKeiyakuIdAndDate(koyouKeiyakuId, date);
    loading.value--
  }

  /**
   * 指定したユーザーの有効な雇用契約就業時間を取得します（オプション値）
   * @param userId? ユーザーID（指定しない場合はログイン中のユーザー）
   */
  const getOptionsByKoyouKeiyakuIdAndDate = async (koyouKeiyakuId: number | null, date: string | Date | null) => {
    loading.value++
    koyouKeiyakuTimeOptions.value = await koyouKeiyakuvice.getOptionsByKoyouKeiyakuIdAndDate(koyouKeiyakuId, date);
    loading.value--
  }

  /**
   * 指定したユーザーの有効な雇用契約就業時間を取得します（オプション値）
   * @param userId? ユーザーID（指定しない場合はログイン中のユーザー）
   */
  const getOptionsOrHayabanOsobanByKoyouKeiyakuIdAndDate = async (koyouKeiyakuId: number | null, date: string | Date | null) => {
    loading.value++
    koyouKeiyakuTimeOptions.value = await koyouKeiyakuvice.getOptionsOrHayabanOsobanByKoyouKeiyakuIdAndDate(koyouKeiyakuId, date);
    loading.value--
  }

  /**
   * 指定したユーザーの有効な雇用契約就業時間を取得します（オプション値）
   * @param userId? ユーザーID（指定しない場合はログイン中のユーザー）
   */
  const getOptionsAndHayabanOsobanByKoyouKeiyakuId = async (koyouKeiyakuId: number | null, userId: number | null, date: string | Date | null) => {
    loading.value++
    koyouKeiyakuTimeAndHayabanOsobanOptions.value = await koyouKeiyakuvice.getOptionsAndHayabanOsobanByKoyouKeiyakuId(koyouKeiyakuId, userId, date);
    loading.value--
  }

  // 読み込み中か判断する
  const isLoading = computed(() => {
    return !(loading.value === 0 || isError.value)
  })

  return {
    isLoading,
    isError,
    koyouKeiyakuList,
    koyouKeiyakuTimeOptions,
    koyouKeiyakuTimeAndHayabanOsobanOptions,
    selectedKoyouKeiyakuTimeOption,
    selectedKoyouKeiyakuTime,
    selectedTimeAndHayabanOsoban,
    getKoyouKeiyakuTimeList: getByKoyouKeiyakuId,
    getKoyouKeiyakuTimeOptions :getOptionsByKoyouKeiyakuId,
    getKoyouKeiyakuTimeListByDate: getByKoyouKeiyakuIdAndDate,
    getKoyouKeiyakuTimeOptionByDate: getOptionsByKoyouKeiyakuIdAndDate,
    getKoyouKeiyakuTimeOrShiftOptionByDate: getOptionsOrHayabanOsobanByKoyouKeiyakuIdAndDate,
    getTimeOptionAndShiftByKoyouKeiykuId: getOptionsAndHayabanOsobanByKoyouKeiyakuId
  }
}
